// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3KXhj","title":"style_title__6wz01","line":"style_line__1Bufg","cards":"style_cards__354gi","trainer":"style_trainer__N5DMI"};